import {
    ADD_MEMBER_PROMOTIONS,
    ADD_MEMBER_PROMOTIONS_ERROR,
    ADD_MEMBER_PROMOTIONS_NOT_ADDED,
    ADD_MEMBER_PROMOTIONS_SUCCESS,
    ADD_PACKAGE_TO_BASKET,
    ADD_PACKAGE_TO_BASKET_ERROR,
    ADD_PACKAGE_TO_BASKET_SUCCESS,
    ADD_TO_BASKET,
    ADD_TO_BASKET_ERROR,
    ADD_TO_BASKET_SUCCESS,
    ADD_VOUCHER_ERROR,
    ADD_VOUCHER_SUCCESS,
    CREATE_BASKET,
    CREATE_BASKET_ERROR,
    CREATE_BASKET_SUCCESS,
    EMPTY_BASKET,
    EMPTY_BASKET_ERROR,
    EMPTY_BASKET_SUCCESS,
    GET_BASKET,
    GET_BASKET_ERROR,
    GET_BASKET_PAYMENT,
    GET_BASKET_PAYMENT_ERROR,
    GET_BASKET_PAYMENT_SUCCESS,
    GET_BASKET_SUCCESS,
    GET_CHECKOUT,
    GET_CHECKOUT_ERROR,
    GET_CHECKOUT_SUCCESS,
    POPULATE_BASKET,
    POPULATE_BASKET_ERROR,
    POPULATE_BASKET_SUCCESS,
    REMOVE_BASKET,
    REMOVE_BASKET_ERROR,
    REMOVE_BASKET_SUCCESS,
    REMOVE_MEMBER_PROMOTIONS,
    REMOVE_MEMBER_PROMOTIONS_ERROR,
    REMOVE_MEMBER_PROMOTIONS_SUCCESS,
    REMOVE_VOUCHER_SUCCESS,
    RESET_GIFT_CARDS,
    RESET_GIFT_CARDS_ERROR,
    RESET_GIFT_CARDS_SUCCESS,
    SET_BASKET,
    SET_BASKET_ADDRESS_ERROR,
    SET_BASKET_ADDRESS_SUCCESS,
    SET_BASKET_ERROR,
    SET_BASKET_SUCCESS,
    SET_FREIGHT_IS_SELECTED,
    SET_PAYMENT_READY,
    UPDATE_BASKET,
    UPDATE_BASKET_ERROR,
    UPDATE_BASKET_ITEM,
    UPDATE_BASKET_ITEM_ERROR,
    UPDATE_BASKET_ITEM_SUCCESS,
    UPDATE_BASKET_PACKAGE_ITEM,
    UPDATE_BASKET_PACKAGE_ITEM_ERROR,
    UPDATE_BASKET_PACKAGE_ITEM_SUCCESS,
    UPDATE_BASKET_SUCCESS,
    UPDATE_PAYMENT_METHOD_SUCCESS,
    VALIDATE_MEMBER_PROMOTIONS,
    VALIDATE_MEMBER_PROMOTIONS_ERROR,
    VALIDATE_MEMBER_PROMOTIONS_SUCCESS,
} from "./constants";

import Cookies from "js-cookie";
import produce from "immer";

const initialState = {
    address: {
        email: null,
        firstName: null,
        lastName: null,
        street: null,
        zipCode: null,
        city: null,
        phoneNumber: null,
    },
    basketId: Cookies.get("basket_id") || null,
    checkoutIsFetched: false,
    comment: "",
    currency: null,
    customerId: "",
    freightIsSelected: false,
    info: [],
    isFetched: false,
    isFetching: false,
    isLoading: false,
    isModifyingItems: false,
    isVirtualBasket: false,
    items: [],
    payment_ready: false,
    payment: {},
    paymentMethods: [],
    payments: [],
    promotions: [],
    promotionsIsLoading: false,
    activeMemberPromotions: [],
    memberPromotionDiscountAmount: null,
    summary: [],
    textComments: [],
    memberPromotionErrors: [],
};

export default produce((state, action) => {
    switch (action.type) {
        case GET_BASKET:
            state.isFetching = true;
            break;
        case POPULATE_BASKET:
        case RESET_GIFT_CARDS:
        case GET_CHECKOUT:
            state.isFetching = true;
            state.checkoutIsFetching = true;
            break;
        case GET_BASKET_SUCCESS:
            state.items = action.items;
            state.basketId = action.basketId;
            state.currency = action.currency;
            state.payments = action.payments;
            state.summary = action.summary;
            state.comment = action.comment;
            state.textComments = action.textComments;
            state.promotions = action.promotions;
            state.info = action.info;
            state.isFetching = false;
            state.isFetched = true;
            state.customerId = action.customerId;
            state.ingrid = action.ingrid;
            state.address = action.address;
            if (action.activeMemberPromotions) {
                state.activeMemberPromotions = action.activeMemberPromotions;
            }
            if (action.memberPromotionDiscountAmount) {
                state.memberPromotionDiscountAmount = action.memberPromotionDiscountAmount;
            }
            break;
        case POPULATE_BASKET_SUCCESS:
        case RESET_GIFT_CARDS_SUCCESS:
        case GET_CHECKOUT_SUCCESS:
            state.items = action.items;
            state.basketId = action.basketId;
            state.currency = action.currency;
            state.payments = action.payments;
            state.summary = action.summary;
            state.comment = action.comment;
            state.textComments = action.textComments;
            state.paymentMethods = action.paymentMethods;
            state.promotions = action.promotions;
            state.info = action.info;
            state.isFetching = false;
            state.isFetched = true;
            state.customerId = action.customerId;
            state.ingrid = action.ingrid;
            state.address = action.address;
            state.checkoutIsFetched = true;
            state.checkoutIsFetching = false;
            state.isVirtualBasket = action.isVirtualBasket;
            if (action.activeMemberPromotions) {
                state.activeMemberPromotions = action.activeMemberPromotions;
            }
            if (action.memberPromotionDiscountAmount) {
                state.memberPromotionDiscountAmount = action.memberPromotionDiscountAmount;
            }
            break;
        case POPULATE_BASKET_ERROR:
        case RESET_GIFT_CARDS_ERROR:
        case GET_BASKET_ERROR:
        case GET_CHECKOUT_ERROR:
            state.isFetching = false;
            state.isFetched = true;
            break;
        case SET_BASKET:
            state.isFetching = true;
            break;
        case SET_BASKET_SUCCESS:
            state.basketId = action.basketId;
            state.isFetching = false;
            break;
        case SET_BASKET_ERROR:
            state.isFetching = false;
            break;
        case UPDATE_BASKET:
            state.isModifyingBasket = true;
            break;
        case UPDATE_BASKET_SUCCESS:
            state.items = action.items;
            state.info = action.info;
            state.comment = action.comment;
            state.summary = action.summary;
            state.isModifyingBasket = false;
            break;
        case UPDATE_BASKET_ERROR:
            state.isModifyingBasket = false;
            break;
        case CREATE_BASKET:
            state.isFetching = true;
            break;
        case CREATE_BASKET_SUCCESS:
            state.basketId = action.basketId;
            state.currency = action.currency;
            state.info = action.info;
            state.customerId = action.customerId;
            state.isFetching = false;
            state.isFetched = true;
            break;
        case CREATE_BASKET_ERROR:
            state.isFetching = false;
            break;
        case ADD_TO_BASKET:
            state.isModifyingItems = true;
            break;
        case ADD_TO_BASKET_SUCCESS:
            state.items = action.items;
            state.info = action.info;
            state.summary = action.summary;
            state.isModifyingItems = false;
            state.isFetched = true;
            break;
        case ADD_TO_BASKET_ERROR:
            state.isModifyingItems = false;
            break;
        case ADD_PACKAGE_TO_BASKET:
            state.isModifyingItems = true;
            break;
        case ADD_PACKAGE_TO_BASKET_SUCCESS:
            state.items = action.items;
            state.summary = action.summary;
            state.isModifyingItems = false;
            state.isFetched = true;
            break;
        case ADD_PACKAGE_TO_BASKET_ERROR:
            state.isModifyingItems = false;
            break;
        case REMOVE_BASKET:
            state.isModifyingItems = true;
            break;
        case REMOVE_BASKET_SUCCESS:
            return { ...initialState, basketId: null, isFetched: true };
        case REMOVE_BASKET_ERROR:
            state.isModifyingItems = false;
            break;
        case UPDATE_BASKET_PACKAGE_ITEM:
        case UPDATE_BASKET_ITEM:
            state.isModifyingItems = true;
            break;
        case UPDATE_BASKET_PACKAGE_ITEM_SUCCESS:
        case UPDATE_BASKET_ITEM_SUCCESS:
            state.items = action.items;
            state.summary = action.summary;
            state.info = action.info;
            state.promotions = action.promotions;
            state.isModifyingItems = false;
            state.addedItem = action.basketItemId;
            break;
        case UPDATE_BASKET_PACKAGE_ITEM_ERROR:
        case UPDATE_BASKET_ITEM_ERROR:
            state.isModifyingItems = false;
            break;
        case EMPTY_BASKET:
            state.isModifyingItems = true;
            break;
        case EMPTY_BASKET_SUCCESS:
            state.isModifyingItems = false;
            break;
        case EMPTY_BASKET_ERROR:
            break;
        case SET_BASKET_ADDRESS_SUCCESS:
            state.address = action.address;
            break;
        case SET_BASKET_ADDRESS_ERROR:
            state.address = {};
            break;
        case GET_BASKET_PAYMENT:
            break;
        case GET_BASKET_PAYMENT_SUCCESS:
            state.payment = action.payment;
            break;
        case GET_BASKET_PAYMENT_ERROR:
            break;
        case ADD_VOUCHER_SUCCESS:
        case REMOVE_VOUCHER_SUCCESS:
            state.items = action.items;
            state.summary = action.summary;
            state.promotions = action.promotions;
            break;
        case ADD_VOUCHER_ERROR:
            state.promotions = [];
            break;
        case VALIDATE_MEMBER_PROMOTIONS:
        case ADD_MEMBER_PROMOTIONS:
        case REMOVE_MEMBER_PROMOTIONS:
            state.promotionsIsLoading = true;
            break;
        case ADD_MEMBER_PROMOTIONS_SUCCESS:
        case REMOVE_MEMBER_PROMOTIONS_SUCCESS:
            state.items = action.items;
            state.summary = action.summary;
            state.promotions = action.promotions;
            state.info = action.info;
            state.activeMemberPromotions = action.activeMemberPromotions || [];
            state.memberPromotionDiscountAmount = action.memberPromotionDiscountAmount || null;
            state.payments = action.payments;
            state.promotionsIsLoading = false;
            state.memberPromotionErrors = [];
            break;
        case ADD_MEMBER_PROMOTIONS_ERROR:
            state.promotionsIsLoading = false;
            state.memberPromotionErrors = action.promotionErrorIds || [];
            break;
        case ADD_MEMBER_PROMOTIONS_NOT_ADDED:
            state.memberPromotionErrors = action.promotionErrorIds || [];
            state.promotionsIsLoading = false;
            state.items = action.items;
            state.summary = action.summary;
            state.promotions = action.promotions;
            state.info = action.info;
            state.payments = action.payments;
            state.activeMemberPromotions = [];
            state.memberPromotionDiscountAmount = null;
            break;
        case REMOVE_MEMBER_PROMOTIONS_ERROR:
        case VALIDATE_MEMBER_PROMOTIONS_SUCCESS:
        case VALIDATE_MEMBER_PROMOTIONS_ERROR:
            state.promotionsIsLoading = false;
            break;
        case SET_PAYMENT_READY:
            state.payment_ready = action.paymentIsReady;
            break;
        case SET_FREIGHT_IS_SELECTED:
            state.freightIsSelected = action.freightIsSelected;
            break;
        case UPDATE_PAYMENT_METHOD_SUCCESS:
            state.paymentMethods = action.paymentMethods;
            break;
        default:
            break;
    }
}, initialState);
